/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { CalendarX2, Replace } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
export function SolicitarMudancaOsPage() {
  const ns = '/bff/v1/j06-s05-solicitar-mudanca';
  const [s, setS] = useState<any>();
  const [tipo, setTipo] = useState('CANCELAMENTO');
  const [vigencia, setVigencia] = useState('2026-10-01');
  const [motivo, setMotivo] = useState(
    'Indisponibilidade operacional futura comunicada pelo credenciado.',
  );
  const [recurso, setRecurso] = useState('');
  async function call(path: string, body?: any) {
    const r = await chamarApi<any>(ns + path, {
      metodo: path === '/state' ? 'GET' : 'POST',
      corpo: body,
    });
    setS(r.state);
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s) return <main role="status">Carregando ordens…</main>;
  const o = s.ordens[0];
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <h1 className="text-3xl font-semibold">{s.titulo}</h1>
      <p>{s.descricao}</p>
      {s.alertas?.map((a: any) => (
        <div role="alert" className="rounded-md border border-destructive p-3" key={a.mensagem}>
          {a.mensagem}
        </div>
      ))}
      {o && (
        <section className="space-y-3 rounded-md border p-4">
          <h2 className="font-semibold">
            OS #{o.numero} · revisão {o.revisao}
          </h2>
          <label className="block">
            Tipo
            <select
              className="mt-1 block w-full rounded-md border bg-background p-2"
              value={tipo}
              onChange={(e) => setTipo(e.target.value)}
            >
              <option value="CANCELAMENTO">Cancelamento futuro</option>
              <option value="SUBSTITUICAO">Substituição</option>
            </select>
          </label>
          {tipo === 'SUBSTITUICAO' && (
            <label className="block">
              ID do novo recurso
              <input
                className="mt-1 block w-full rounded-md border bg-background p-2"
                value={recurso}
                onChange={(e) => setRecurso(e.target.value)}
              />
            </label>
          )}
          <label className="block">
            Vigência
            <input
              type="date"
              className="mt-1 block w-full rounded-md border bg-background p-2"
              value={vigencia}
              onChange={(e) => setVigencia(e.target.value)}
            />
          </label>
          <label className="block">
            Motivo
            <textarea
              className="mt-1 block w-full rounded-md border bg-background p-2"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
            />
          </label>
          <Button
            onClick={() =>
              void call('/verbs/solicitar_mudanca', {
                ordemServicoId: o.id,
                tipo,
                recursoNovoId: recurso || undefined,
                vigencia,
                motivo,
                chaveIdempotencia: `j06-s05-${o.id}-${tipo}-${vigencia}`,
              })
            }
          >
            <Replace className="mr-2 h-4 w-4" />
            Solicitar mudança
          </Button>
        </section>
      )}
      <section aria-label="Solicitações">
        <h2 className="font-semibold">Linha do tempo de solicitações</h2>
        {s.solicitacoes.map((m: any) => (
          <p key={m.id}>
            {m.tipo} · {m.vigencia} · {m.status} · {m.motivo}
          </p>
        ))}
      </section>
    </main>
  );
}
export function DecidirMudancaOsPage() {
  const ns = '/bff/v1/j06-s05-decidir-mudanca';
  const [s, setS] = useState<any>();
  async function call(path: string, body?: any) {
    const r = await chamarApi<any>(ns + path, {
      metodo: path === '/state' ? 'GET' : 'POST',
      corpo: body,
    });
    setS(r.state);
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s) return <main role="status">Carregando solicitações…</main>;
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <h1 className="text-3xl font-semibold">{s.titulo}</h1>
      <p>{s.descricao}</p>
      {s.alertas?.map((a: any) => (
        <div role="alert" className="rounded-md border border-destructive p-3" key={a.mensagem}>
          {a.mensagem}
        </div>
      ))}
      <section className="space-y-3">
        {s.solicitacoes.map((m: any) => (
          <article className="rounded-md border p-4" key={m.id}>
            <h2 className="font-semibold">
              {m.tipo} · {m.status}
            </h2>
            <p>
              Vigência {m.vigencia} · {m.motivo}
            </p>
            {m.status === 'PENDENTE' ? (
              <div className="mt-3 flex gap-2">
                <Button
                  onClick={() =>
                    void call('/verbs/decidir_mudanca', {
                      solicitacaoId: m.id,
                      decisao: 'APROVADA',
                    })
                  }
                >
                  <CalendarX2 className="mr-2 h-4 w-4" />
                  Aprovar
                </Button>
                <Button
                  variant="outline"
                  onClick={() =>
                    void call('/verbs/decidir_mudanca', {
                      solicitacaoId: m.id,
                      decisao: 'REJEITADA',
                    })
                  }
                >
                  Rejeitar
                </Button>
              </div>
            ) : m.status === 'APROVADA' ? (
              <Button
                className="mt-3"
                variant="outline"
                onClick={() =>
                  void call('/verbs/decidir_mudanca', { solicitacaoId: m.id, decisao: 'APROVADA' })
                }
              >
                Repetir aprovação
              </Button>
            ) : null}
          </article>
        ))}
      </section>
      <section>
        <h2 className="font-semibold">Revisões vigentes por data</h2>
        {s.revisoes.map((r: any) => (
          <p key={`${r.ordemServicoId}-${r.revisao}`}>
            Revisão {r.revisao}: {r.inicio} a {r.fim} · {r.status} · {r.motivo}
          </p>
        ))}
      </section>
    </main>
  );
}
